import SubscriptionImage from "../../assets/images/Subscription.jpg";
import NtripRTKImage from "../../assets/images/NtripRTK.jpg";
import StreamingImage from "../../assets/images/Streaming.jpg";

export const getProductThumbnail = (product) => {
  const productLabel = `${product.title || ""} ${product.name || ""}`;

  if (/subscription/i.test(productLabel)) {
    return SubscriptionImage;
  }

  if (/ntrip\s*rtk|rtk\s*ntrip/i.test(productLabel)) {
    return NtripRTKImage;
  }

  return StreamingImage;
};

export const getProductImageBackground = (product) => {
  const productLabel = `${product.title || ""} ${product.name || ""}`;

  if (/subscription|ntrip\s*rtk|rtk\s*ntrip/i.test(productLabel)) {
    return "#fff";
  }

  return "#07393d";
};
